import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { verifyEmail } from "../../api/auth";
import { Box, Typography, CircularProgress } from "@mui/material";

export default function VerifyEmailPage() {
  const { token } = useParams();
  const [status, setStatus] = useState("verifying");

  useEffect(() => {
    verifyEmail(token)
      .then(() => setStatus("success"))
      .catch(() => setStatus("error"));
  }, [token]);

  return (
    <Box textAlign="center" mt={10}>
      {status === "verifying" && <CircularProgress />}
      {status === "success" && (
        <Typography>Email verified successfully!</Typography>
      )}
      {status === "error" && (
        <Typography color="error">Verification failed or expired.</Typography>
      )}
    </Box>
  );
}
